<template>
  <span class="price" :class="{ token }">{{ parsedValue }}</span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

defineOptions({ name: 'Price' })

const props = withDefaults(
  defineProps<{
    token?: boolean
    value?: number
  }>(),
  {
    token: false,
    value: 0,
  },
)

const parsedValue = computed(() => (props.token ? props.value : (props.value / 100).toFixed(2)))
</script>

<style scoped lang="scss">
.price {
  color: white;
  font-weight: 700;

  &:not(.token)::before {
    padding-right: 0.25ex;
    content: '$';
    font-weight: 600;
    background-image: linear-gradient(145.12deg, #26f9e0 8.43%, #d9e55e 98.72%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  &.token::after {
    padding-left: 0.25ex;
    content: 'token';
    font-weight: 100;
    color: #e46a4f;
  }
}
</style>
